export interface Account {
  id: number;
  login: string;
  name: string;
  password: string;
  confirmationPassword: string;
  email: string;
  createdDate: Date | null;
  accountGroupID: number;
  active: boolean;
  companyID: number | null;
  companyName: string;
  preRegistration: boolean;
  accessPlanID: number | null
}

export const accountDefault = ({ companyID }: { companyID: number | null } = { companyID: null }): Account => {
  return {
    id: 0,
    login: "",
    name: "",
    password: "",
    email: "",
    accountGroupID: 0,
    active: true,
    companyID,
    companyName: "",
    createdDate: null,
    confirmationPassword: "",
    preRegistration: false,
    accessPlanID: null
  }
}
